<template>
  <div id="wrapper" class="page">
    <meeting-side-bar index="3" />
    <div id="content-wrapper">
      <div class="container-fluid">
        <!-- <b-link href="#" @click.prevent="openModal">
          <i class="fas fa-plus mr-2"></i> Thêm
        </b-link>-->
        <button class="btn btn-info mb-2" @click.prevent="openModal" v-if="meeting_create">
          <i class="fas fa-plus"></i> Thêm
        </button>
        <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="fields"
          :items="items"
        >
          <template v-slot:cell(use)="data">
            <template v-if="data.item.use">
              <span aria-hidden="true">&check;</span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true">&nbsp;</span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
          <template v-slot:cell(color)="data">
            <div
              v-bind:style="{ 'background-color': data.value}"
              style="width: 42px; height: 42px;border-radius: 10px;"
            ></div>
          </template>
          <template v-slot:cell(action)="data">
            <b-link class="text-primary mr-2" href="#" @click.prevent="openUpdateModal(data)" v-if="meeting_update">
                <i class="fas fa-pencil-alt"></i>
            </b-link>
            <b-link class="text-danger" href="#" @click.prevent="deleteItem(data)" v-if="meeting_delete">
                <i class="fas fa-trash"></i>
            </b-link>
            <!-- <button class="btn btn-info mr-1" @click="openUpdateModal(data)" v-if="meeting_udpate">
              <i class="fas fa-pencil-alt"></i>
            </button>
            <button class="btn btn-danger" @click="deleteItem(data)" v-if="meeting_delete">
              <i class="fas fa-trash-alt"></i>
            </button>             -->
          </template>
        </b-table>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      @ok="storeItem"
      header-bg-variant="info"
      header-text-variant="light"
    >
      <template v-slot:modal-title>
        <div v-if="item.id <= 0">Thêm phòng họp</div>
        <div v-else>Cập nhật phòng họp</div>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="info" @click="ok()"><i class="fas fa-save mr-2"></i>Lưu</b-button>
        <b-button variant="secondary" @click="cancel()"><i class="fas fa-times mr-2"></i>Đóng</b-button>
      </template>
      <b-container>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Tên phòng
                <span class="text-danger">*</span>
              </template>
              <b-form-input v-model="item.name" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>
                Màu
                <span class="text-danger">*</span>
              </template>
              <v-swatches v-model="item.color" swatches="text-advanced" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <template v-slot:label>Ghi chú</template>
              <b-form-input v-model="item.note" required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <b-form-checkbox v-model="item.use">Được sử dụng</b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col cols="7">
            <b-form-group>
              <b-form-checkbox v-model="item.multibooking">Cho phép đăng ký nhiều lần</b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import MeetingSideBar from "../components/Meeting/MeetingSideBar";
import VSwatches from "vue-swatches";
// Import the styles too, globally
import "vue-swatches/dist/vue-swatches.css";
export default {
  name: "Meetings",
  components: {
    MeetingSideBar,
    VSwatches,
  },
  data() {
    return {
      fields: [
        {
          key: "name",
          label: "Name",
        },
        {
          key: "color",
          label: "Color",
        },
        {
          key: "note",
          label: "Note",
        },
        {
          key: "use",
          label: "Usage",
        },
        {
          key: "action",
          label: "",
          thStyle: { width: "50px !important" },
        },
      ],
      items: [],
      item_null: {
        id: 0,
        name: null,
        use: true,
        note: null,
        color: null,
      },
      item: {
        id: 0,
        name: null,
        use: true,
        note: null,
        color: null,
        multibooking: false,
      },
      modalShow: false,
      url: "/api/meeting/",
    };
  },
  computed: {
    meeting_create() {
      return this.$store.getters.hasPermission("meeting_create");
    },
    meeting_update() {
      return this.$store.getters.hasPermission("meeting_update");
    },
    meeting_delete() {
      return this.$store.getters.hasPermission("meeting_delete");
    },
  },
  beforeRouteEnter(to, from, next) {
    axios
      .get("/api/meeting")
      .then((response) => {
        next((vm) => vm.initData(response.data));
      })
      .catch((err) => {
        next();
      });
  },
  methods: {
    initData(data) {
      this.items = data;
    },
    openModal() {
      this.item = JSON.parse(JSON.stringify(this.item_null));
      this.modalShow = true;
    },
    openUpdateModal(data) {
      this.item = JSON.parse(JSON.stringify(data.item));
      this.itemIdex = data.index;
      this.modalShow = true;
    },
    storeItem(bvModalEvt) {
      if (!(this.item.name && this.item.name.length) ||
          !(this.item.color && this.item.color.length)) {
        this.$toast.error("Vui lòng nhập đầy đủ thông tin", "Lỗi", {
          timeout: 2000,
        });
        bvModalEvt.preventDefault();
      } else {
        if (this.item.id <= 0) {
          const isItemExist = this.items.filter(
            (x) => x.name.toLowerCase() === this.item.name.toLowerCase()
          );
          if (isItemExist.length > 0) {
            this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
            bvModalEvt.preventDefault();
          } else {
            axios
              .post(this.url, this.item)
              .then((res) => {
                this.modalShow = false;
                this.items.push(res.data);
              })
              .catch((err) => {
                this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
              });
          }
        } else {
          const isItemUpdateExist = this.items.filter(
            (x) =>
              x.name.toLowerCase() === this.item.name.toLowerCase() &&
              x.id !== this.item.id
          );
          if (isItemUpdateExist.length > 0) {
            this.$toast.error("Tên đã tồn tại !", "Lỗi", { timeout: 2000 });
            bvModalEvt.preventDefault();
          } else {
            axios
              .put(this.url, this.item)
              .then((res) => {
                this.modalShow = false;
                this.items[this.itemIdex] = JSON.parse(
                  JSON.stringify(this.item)
                );
                const temp = JSON.parse(JSON.stringify(this.items));
                this.items = JSON.parse(JSON.stringify(temp));
                this.itemIdex = null;
              })
              .catch((err) => {
                this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
              });
          }
        }
      }
    },
    deleteItem(data) {
      this.$toast.question("Bạn có thực sự muốn xóa không?", "Nhắc nhở", {
        timeout: 20000,
        close: false,
        overlay: true,
        displayMode: "once",
        position: "center",
        buttons: [
          [
            "<button><b>Có</b></button>",
            (instance, toast) => {
              axios
                .delete(`${this.url + data.item.id}`)
                .then((res) => {
                  this.items.splice(data.index, 1);
                  this.$toast.success("Xóa thành công !", "Thành công", {
                    timeout: 3000,
                  });
                })
                .catch((err) => {
                  this.$toast.error(err.response.data, "Lỗi", {
                    timeout: 3000,
                  });
                });
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
            true,
          ],
          [
            "<button>Không</button>",
            function (instance, toast) {
              instance.hide({ transitionOut: "fadeOut" }, toast, "button");
            },
          ],
        ],
      });
    },
  },
};
</script>